import { auth0ApiClient } from './auth0ApiClient'
import { User, UserRole, UserStatus } from '@/types/user'

export interface AdminUserListFilters {
  search?: string
  role?: UserRole
  status?: UserStatus
  page?: number
  limit?: number
}

export interface AdminUserListPagination {
  page: number
  limit: number
  totalDocs: number
  totalPages: number
  hasNextPage: boolean
  hasPrevPage: boolean
}

export interface AdminUserListResponse {
  users: User[]
  pagination: AdminUserListPagination
}

interface AdminUserListEnvelope {
  success: boolean
  data: AdminUserListResponse
}

class AdminUserService {
  private readonly baseUrl = '/users/admin/users'

  async listUsers(filters: AdminUserListFilters = {}): Promise<AdminUserListResponse> {
    const envelope = await auth0ApiClient.getEnvelope<AdminUserListEnvelope>(this.baseUrl, {
      params: {
        search: filters.search || undefined,
        role: filters.role || undefined,
        status: filters.status || undefined,
        page: filters.page,
        limit: filters.limit
      }
    })
    return envelope.data
  }

  async getUserById(id: string): Promise<User> {
    return auth0ApiClient.get<User>(`/users/${id}`)
  }

  async suspendUser(id: string, reason: string): Promise<User> {
    return auth0ApiClient.post<User>(`${this.baseUrl}/${id}/suspend`, { reason })
  }

  async reactivateUser(id: string, reason: string): Promise<User> {
    return auth0ApiClient.post<User>(`${this.baseUrl}/${id}/reactivate`, { reason })
  }

  async changeUserRole(id: string, role: UserRole, reason: string): Promise<User> {
    return auth0ApiClient.post<User>(`${this.baseUrl}/${id}/role`, { role, reason })
  }
}

export const adminUserService = new AdminUserService()
